import { NavigationBar } from './NavigationBar.class';
import { Component, defineComponent } from 'vue';
import Skeleton from '../skeleton/Skeleton.vue';
import ExpandableContent from '../expandable-content/ExpandableContent.vue';
import Breadcrumbs from '../breadcrumbs/Breadcrumbs.vue';
export default defineComponent({
	components: {
		Skeleton: Skeleton as Component,
		ExpandableContent: ExpandableContent as Component,
		Breadcrumbs: Breadcrumbs as Component,
	},
	setup: () => {
		const codeBehind = new NavigationBar();
		return {
			...codeBehind,
			switchToTab: codeBehind.switchToTab.bind(codeBehind),
			toggleExpand: codeBehind.toggleExpand.bind(codeBehind),
		};
	},
});
